import { type ParsedStore } from '@service-initiation/tech-care-data-access-tech-care-services';

export const nextDayStoreIsOpenIndex = (
  storeHours: ParsedStore['hours']['all'],
  weekDayIndex: number
): number => {
  for (let i = weekDayIndex + 1; i < storeHours.length + weekDayIndex; i++) {
    const index = i % storeHours.length;
    const schedule = storeHours[index];

    if (
      schedule &&
      typeof schedule !== 'boolean' &&
      schedule.open &&
      schedule.open !== null
    ) {
      return index;
    }
  }

  return -1;
};
